import $ from 'jquery';

$(function(){
	
	if($('.load-splash').length == 1) {
	
		var splashScreenMinDuration = 2000;
		
		var d = new Date();
		var pageLoadStart = d.getMilliseconds();
		
		
		$(window).ready(function(){
			
			var d = new Date();
			var pageLoadDuration = d.getMilliseconds() - pageLoadStart;
			var hideSplashDelay = Math.max(0, (splashScreenMinDuration - pageLoadDuration));
			setTimeout(function(){
				$('body')[0].scrollTop = 0;
				$('.load-splash').addClass('hide');
				setTimeout(function(){
					$('.load-splash').remove();
				}, 350);
			}, hideSplashDelay);
			
		});
		
	}

});